module.exports = __webpack_public_path__ + "img/message.daeba6a3.png";